import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';

import logo from '../../images/GR_LOGO_Primary.png';
import './authentication.css';

class Frame extends Component {
  render() {
    const footerText = `© ${new Date().getFullYear()} Grassrootz`;

    return (
      <div className="auth-page">
        {this.props.error && (
          <div
            key={this.props.error.id}
            id={this.props.error.id}
            className="authentication-error hide-me"
          >
            <Translate value={this.props.error.key} />
          </div>
        )}
        <div className="authentication-frame">
          <div className="logo-cont">
            <img src={logo} className="logo" alt="logo" width="100%" />
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Frame;
